import React, { Component } from 'react';
import ErrorPage from 'pages/ErrorPage';
import { delay } from 'lodash';

class ErrorBoundary extends Component {
  state = { hasError: false, reloadCount: 0 };

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (
      process.env.NODE_ENV === 'production' &&
      (error?.message?.indexOf('loading chunk') !== -1 || error?.message?.indexOf('Loading CSS chunk') !== -1) &&
      this.state.reloadCount < 2
    ) {
      window.location.reload();
    } else {
      console.error(error, errorInfo);
    }
  }
  render() {
    const { children, ...rest } = this.props;

    // * Handled chunk failed error. just refresh one time again
    const handleReloadOnError = () => {
      const hasRefreshed = sessionStorage.getItem('retry-lazy-refreshed') || 'false';
      try {
        if (hasRefreshed && hasRefreshed === 'true') {
          sessionStorage.setItem('retry-lazy-refreshed', 'false');
        } else {
          throw new Error();
        }
      } catch (error) {
        sessionStorage.setItem('retry-lazy-refreshed', 'true'); // we are now going to refresh

        delay(() => {
          return window.location.reload(); // refresh the page
        }, 400);
      }
    };

    if (this.state.hasError) {
      console.log('error.........')
      // (function () {
      //   window.addEventListener('error', e => {
      //     if (/Loading chunk [\d]+ failed/.test(e.message)) {
      //       handleReloadOnError();
      //     }
      //   });
      // })();
      return <ErrorPage />;
    }
    return children;
  }
}

export default ErrorBoundary;
